<template>
    <div class="flex-1 min-w-0">
        <div class="max-w-6xl mx-auto px-4 py-6">

            <div class="mb-6">
                <h1 class="text-2xl font-bold text-gray-800">{{ __(saluto) }}</h1>
                <p class="text-sm text-gray-500">{{ __('Cosa vuoi fare oggi?') }}</p>
            </div>

            <!-- Promemoria bozze: compare SOLO se ce ne sono. E' l'unica informazione
                 della home che non espone niente di nostro: e' una dimenticanza del
                 cliente, e senza questo avviso se ne accorge quando la merce non parte. -->
            <router-link v-if="bozze.numero > 0" to="/bollettazione/elenco"
                class="flex items-center gap-4 mb-8 p-4 bg-yellow-50 border-l-4 border-yellow-400 rounded-lg shadow-sm hover:shadow-md transition">
                <span class="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-lg bg-yellow-100 text-yellow-700">
                    <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round">
                        <path d="M6 3h9l4 4v14H6z" /><path d="M15 3v4h4" /><path d="M9 13h6M9 17h4" />
                    </svg>
                </span>
                <span class="flex-1 min-w-0">
                    <span class="block font-bold text-gray-800">
                        {{ bozze.numero }} {{ bozze.numero === 1 ? __('spedizione da trasmettere') : __('spedizioni da trasmettere') }}
                    </span>
                    <span class="block text-sm text-gray-600">
                        {{ bozze.numero === 1 ? __('Finché non la trasmetti non parte.') : __('Finché non le trasmetti non partono.') }}
                        <span v-if="quandoPiuVecchia">{{ quandoPiuVecchia }}</span>
                    </span>
                </span>
                <span class="flex-shrink-0 text-sm font-bold text-red-600 whitespace-nowrap">{{ __('vai all\'elenco') }} →</span>
            </router-link>

            <!-- I gruppi vengono dal menu: le voci senza tendina insieme in cima (senza
                 titolo, perche' cambiano da un ruolo all'altro), poi una sezione per ogni
                 voce con la tendina, col nome della voce. Una voce aggiunta domani dalla
                 pagina Crea menu compare da sola, nel gruppo giusto. -->
            <section v-for="(gruppo, g) in gruppi" :key="'g' + g" class="mb-8">
                <h2 v-if="gruppo.titolo"
                    class="flex items-center gap-3 mb-3 text-xs font-bold uppercase tracking-wider text-gray-400">
                    <span>{{ gruppo.titolo }}</span>
                    <span class="flex-1 h-px bg-gray-200"></span>
                </h2>
                <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    <router-link v-for="(voce, v) in gruppo.voci" :key="'v' + g + '-' + v" :to="voce.link"
                        class="group flex items-center gap-4 p-4 bg-white rounded-lg shadow-sm ring-1 ring-gray-200 border-l-4 border-red-600 hover:shadow-md transition"
                        style="min-height: 88px">
                        <span class="flex-shrink-0 flex items-center justify-center w-11 h-11 rounded-lg bg-red-50 text-red-600">
                            <svg class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
                                stroke-linecap="round" stroke-linejoin="round" v-html="icona(voce.link)"></svg>
                        </span>
                        <span class="flex-1 min-w-0">
                            <span class="block font-bold text-gray-800">{{ voce.name }}</span>
                            <span v-if="descrizione(voce.link)" class="block text-sm text-gray-500 leading-snug">
                                {{ __(descrizione(voce.link)) }}
                            </span>
                        </span>
                        <span class="flex-shrink-0 text-xl text-gray-300 group-hover:text-red-600">›</span>
                    </router-link>
                </div>
            </section>

        </div>
    </div>
</template>
<script>
/**
 * Pagina iniziale.
 *
 * 29/09/2026: prima erano grossi blocchi rossi tutti uguali, uno per voce di menu.
 * Ora le stesse voci, raggruppate come il menu, con icona e una riga di spiegazione,
 * piu' il promemoria delle bozze non confermate (vedi mockup-home\home_A_vestita.html).
 *
 * Icone e descrizioni stanno nelle due tabelle qui sotto, per indirizzo. Una voce che
 * li' non c'e' (per esempio le voci degli amministratori) compare lo stesso, con
 * un'icona generica e senza descrizione: non sparisce niente.
 */

// L'interno di un <svg viewBox="0 0 24 24"> disegnato a tratto.
const ICONE = {
    '/spedizioni':             '<path d="M3 6h11v9H3z"/><path d="M14 9h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>',
    '/storicopod':             '<path d="M6 3h9l4 4v14H6z"/><path d="M15 3v4h4"/><path d="M9 16c1.2-1.6 2-1.6 2.6 0s1.4 1.6 2.6 0 1.6-.8 2 .2"/>',
    '/localita-disagiate':     '<path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/>',
    '/aggiungiprenotazione':   '<rect x="3.5" y="5" width="17" height="15" rx="2"/><path d="M3.5 9.5h17M8 3v4M16 3v4M12 12.5v5M9.5 15h5"/>',
    '/visualizzaprenotazioni': '<rect x="3.5" y="5" width="17" height="15" rx="2"/><path d="M3.5 9.5h17M8 3v4M16 3v4M9 15l2 2 4-4"/>',
    '/bollettazione':          '<rect x="3.5" y="3.5" width="17" height="17" rx="3"/><path d="M12 8v8M8 12h8"/>',
    '/bollettazione/elenco':   '<path d="M9 6h11M9 12h11M9 18h11"/><circle cx="4.5" cy="6" r="1"/><circle cx="4.5" cy="12" r="1"/><circle cx="4.5" cy="18" r="1"/>',
};
const ICONA_GENERICA = '<rect x="4" y="4" width="16" height="16" rx="3"/><path d="M10 9l3 3-3 3"/>';

const DESCRIZIONI = {
    '/spedizioni':             'Dove si trova la tua merce, in tempo reale',
    '/storicopod':             'Le prove di consegna firmate',
    '/localita-disagiate':     'Le località a consegna disagiata',
    '/aggiungiprenotazione':   'Chiedi un ritiro presso di te',
    '/visualizzaprenotazioni': 'I ritiri già prenotati e il loro stato',
    '/bollettazione':          'Nuova spedizione, con LDV ed etichette',
    '/bollettazione/elenco':   'Bozze, conferme e documenti da stampare',
};

/** '/Spedizioni/' e 'spedizioni' devono trovare la stessa riga delle tabelle. */
function normalizza(link) {
    let l = String(link || '').trim().toLowerCase();
    if (l && l.charAt(0) !== '/') l = '/' + l;
    if (l.length > 1) l = l.replace(/\/+$/, '');
    return l;
}

export default {
    data() {
        return {
            bozze: { numero: 0, piuVecchia: null }
        }
    },
    computed: {
        /**
         * Computed e non copia fatta in created(), come prima: se il menu arriva
         * dal server un attimo dopo che la pagina e' nata, la pagina si aggiorna da
         * sola invece di restare vuota.
         */
        gruppi() {
            const menu = this.$store.state.menuItems || [];
            const sfuse = [];
            const conTendina = [];
            menu.forEach(voce => {
                const figli = voce.sub_menu_items || [];
                if (figli.length === 0) {
                    sfuse.push(voce);
                } else {
                    conTendina.push({ titolo: voce.name, voci: figli });
                }
            });
            return (sfuse.length ? [{ titolo: '', voci: sfuse }] : []).concat(conTendina);
        },
        /** Si chiede il conteggio solo a chi ha la bollettazione nel menu. */
        haBollettazione() {
            // Senza utente caricato non si chiede niente: il getter 'uri' in quel caso
            // restituisce undefined (e rimanda al login), e la chiamata partiva verso
            // /api/undefined/bollettazione/bozze -> 405. Visto il 30/09 a sessione scaduta.
            if (!this.$store.state.user) return false;
            return this.gruppi.some(g => g.voci.some(v => normalizza(v.link).indexOf('/bollettazione') === 0));
        },
        saluto() {
            return new Date().getHours() < 17 ? 'Buongiorno' : 'Buonasera';
        },
        /** "La più vecchia è di ieri, ore 17:46" — dalla stringa del database, senza fusi orari. */
        quandoPiuVecchia() {
            const m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/.exec(this.bozze.piuVecchia || '');
            if (!m || this.bozze.numero < 2) return '';
            const giorno = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
            const oggi = new Date(); oggi.setHours(0, 0, 0, 0);
            const diff = Math.round((oggi - giorno) / 86400000);
            const ora = m[4] + ':' + m[5];
            if (diff === 0) return this.__('La più vecchia è di oggi, ore') + ' ' + ora + '.';
            if (diff === 1) return this.__('La più vecchia è di ieri, ore') + ' ' + ora + '.';
            return this.__('La più vecchia è del') + ' ' + m[3] + '/' + m[2] + '.';
        }
    },
    watch: {
        haBollettazione: {
            immediate: true,
            handler(si) {
                if (si) this.caricaBozze();
            }
        }
    },
    methods: {
        icona(link) {
            return ICONE[normalizza(link)] || ICONA_GENERICA;
        },
        descrizione(link) {
            return DESCRIZIONI[normalizza(link)] || '';
        },
        /**
         * In silenzio: niente messaggio d'errore e niente rotellina. E' un
         * promemoria; se per qualunque motivo non arriva, la pagina funziona lo
         * stesso e il cliente non deve vedere un errore per una cosa che non ha chiesto.
         */
        async caricaBozze() {
            if (!this.$store.state.user) return;
            try {
                const res = await this.handleCallback(
                    () => this.axios.post(this.$store.getters.uri + '/bollettazione/bozze', {}),
                    false, false, false);
                const v = res && res.value ? res.value : res;
                if (v && typeof v.numero !== 'undefined') {
                    this.bozze = { numero: Number(v.numero) || 0, piuVecchia: v.piu_vecchia || null };
                }
            } catch (e) {
                // vedi sopra: il promemoria non deve mai rompere la pagina
            }
        }
    }
}
</script>
